import * as $ from "jquery";

export default class LinkButtonQueryParamCapture{
  $domRoot: JQuery<HTMLElement>;
  params: any;

  constructor(domRoot: HTMLElement, params: any) {
    this.$domRoot = $(domRoot);
    this.params = { ...params };

    this.init();
  }

  init () {
    var urlParams = new URLSearchParams(window.location.search).toString();
    if (urlParams.length > 0) {
      var $link = this.$domRoot.children("a");
      var oldHref = $link.attr("href");
      if (oldHref?.indexOf("?") != -1) {
        $link.attr("href", oldHref + "&" + urlParams);
      } else {
        $link.attr("href", oldHref + "?" + urlParams);
      }
    }
  }
}
